import { createReducer } from 'src/helpers/reducer';
import actionsTypes from './actionTypes';
import { IChangeModalVisibilityPayload, ILoadDataSuccessPayload, IPendingSkillModalState } from './types';

const initState: IPendingSkillModalState = {
  isLoading: false,
  isModalVisible: false,
  loadDataAction: undefined,
  assessments: undefined,
  experiences: undefined,
  skills: undefined,
};

function onChangeModalVisibility(
  state: IPendingSkillModalState,
  { payload }: { payload: IChangeModalVisibilityPayload },
) {
  const { loadDataAction } = payload;

  return {
    ...state,
    isModalVisible: !state.isModalVisible,
    loadDataAction,
  };
}

function onClearState() {
  return {
    ...initState,
  };
}

function onProcessActionRequest(state: IPendingSkillModalState) {
  return {
    ...state,
    isLoading: true,
  };
}

function onProcessActionSuccess(state: IPendingSkillModalState) {
  return {
    ...state,
    isLoading: false,
  };
}

function onProcessActionError(state: IPendingSkillModalState) {
  return {
    ...state,
    isLoading: false,
  };
}

function onLoadReviewPendingDataSuccess(
  state: IPendingSkillModalState,
  { payload }: { payload: ILoadDataSuccessPayload },
) {
  const { assessments, experiences, skills } = payload;

  return {
    ...state,
    isLoading: false,
    assessments,
    experiences,
    skills,
  };
}

export default createReducer(initState, {
  [actionsTypes.CHANGE_MODAL_VISIBILITY]: onChangeModalVisibility,
  [actionsTypes.CLEAR_STATE]: onClearState,
  [actionsTypes.PROCESS_ACTION_REQUEST]: onProcessActionRequest,
  [actionsTypes.PROCESS_ACTION_SUCCESS]: onProcessActionSuccess,
  [actionsTypes.PROCESS_ACTION_ERROR]: onProcessActionError,
  [actionsTypes.LOAD_REVIEW_PENDING_DATA_SUCCESS]: onLoadReviewPendingDataSuccess,
});
